import {memo} from 'react'
import type {ProgressiveDiffEntry} from '../../types/progressive-diff-types'
import {DiffEntryLoadingSkeleton} from './DiffEntryLoadingSkeleton'
import {useIntersectionObserver} from '@github-ui/use-sticky-header/useIntersectionObserver'
import {useProgressiveDiffActions} from '../../stores/selectors'

export const LazyDiffEntryLoadingSkeleton = memo(function LazyDiffEntryLoadingSkeletonComponent({
  progressiveDiffEntry,
  approximateLineCount = 5,
}: {
  progressiveDiffEntry: ProgressiveDiffEntry
  approximateLineCount?: number
}) {
  const {loadPriority} = useProgressiveDiffActions()

  // Load entry when it enters viewport
  const sentinelRef = useIntersectionObserver(
    entries => {
      if (entries[0]?.isIntersecting) {
        // calling loadPriority multiple times is accounted for
        loadPriority(progressiveDiffEntry.pathDigest)
      }
    },
    {
      // these ensure the observer doesnt fire prematurely and cause content to jump
      rootMargin: '-150px',
    },
  )

  return (
    <div ref={sentinelRef}>
      <DiffEntryLoadingSkeleton
        ariaLabel={`Loading ${progressiveDiffEntry.path}`}
        testId={`lazy-load-${progressiveDiffEntry.path}`}
        id={`diff-${progressiveDiffEntry.pathDigest}`}
        approximateLineCount={approximateLineCount}
      />
    </div>
  )
})
